import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ShopeeOpenServiceV2 } from 'src/app/shared/services';
import { shopeeStoreProviders } from 'src/app/shared/config/store-config';
import { ShopeeOrdersComponent } from '../../../shared/components/shopee-orders/shopee-orders.component';

@Component({
    selector: 'app-quick-orders',
    templateUrl: './shopee-genlogic-order-page.component.html',
    styleUrls: ['./shopee-genlogic-order-page.component.scss'],
    providers: [
        ...shopeeStoreProviders('shopee-genlogic'),
        ShopeeOpenServiceV2,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ShopeeOrdersComponent],
})
export class ShopeeGenLogicOrderPageComponent {
    constructor() {}
}
